import styled from 'styled-components';

const Loading = styled.div`
    text-align:center;

`;

export default Loading;